var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebtsInformal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5F50F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.0001L20.9999 18.0002C21.3904 17.6096 22.0236 17.6096 22.4141 18.0002L27.414 23.0001L29.2802 21.1338C29.4377 20.9763 29.707 21.0879 29.707 21.3106V26.4571C29.707 26.5951 29.5951 26.7071 29.457 26.7071H24.3106C24.0878 26.7071 23.9763 26.4378 24.1338 26.2803L26 24.4141L21.707 20.1211L17.7071 24.121C17.3166 24.5115 16.6834 24.5115 16.2929 24.121L9.99997 17.8281C9.6095 17.4376 9.6095 16.8045 9.99997 16.4141C10.3904 16.0236 11.0235 16.0236 11.414 16.4141L17 22.0001Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtsInformal);
export default __webpack_public_path__ + "static/media/debtsInformal.bbada6804fccd6e941ee941eb258fc15.svg";
export { ForwardRef as ReactComponent };